import { render } from "./EmbeddedGenogramLegendRow.vue?vue&type=template&id=84f94912"
import script from "./EmbeddedGenogramLegendRow.vue?vue&type=script&lang=js"
export * from "./EmbeddedGenogramLegendRow.vue?vue&type=script&lang=js"

import "./EmbeddedGenogramLegendRow.vue?vue&type=style&index=0&id=84f94912&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__